import * as R from 'ramda'

import schemaModule from '../../utils/schema/index.js'

import { reqData } from '../purchaseReq/index.js'

const schema = R.pipe(
  R.dissocPath(['contents', 'items']),
  R.assocPath(['contents', 'items'], {
    type: 'Array',
    contents: [{ type: 'ObjectId', reference: 'purchaseItems' }],
  }),
  schemaModule.create,
)(reqData.schema)

const index = {
  items: {
    key: { items: 1 },
  },
  sellerRef: {
    key: { sellerRef: 1, status: 1 },
  },
}

export default {
  schema,
  index,
}
